module.exports = __webpack_public_path__ + "img/shipping-bill.8bfac9c6.png";